export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-vacancies.vue?vue&type=template&id=79f10122&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-vacancies.vue?vue&type=template&id=79f10122&
// module id = 1265
// module chunks = 0